export const APPLY_PIC = 'https://cdn.vip-wifi.com/njxfy/img/share/consultants-apply.png?v=1'
export const DEFAULT_PER = 10
